import '../css/login.css';
import './login-victor'

layui.use([], ()=> {
    const {layer, form, $, util, cache} = layui;
    // 全局保存消息监听引用，防止被提前移除
    let loginType = 0;

    window.Victor("login-background", "output");

    form.on('submit(login)', (data) => {
        let field = data.field; // 获取表单字段值
        $.ajax({
            url:`${cache.BASE_API}login`,
            data: field,
            type:'post', dataType:'json',
            success: (data) => {
                if (data.code === 0) {
                    // localStorage.setItem(`token`,JSON.stringify({"token":data.data.token, "expr": new Date().getDate()}))
                    // document.cookie = `token=${data.data.token};path=/`;
                    location.href = `/`;
                } else {
                    message(data.msg)
                }
            },
        })
        return false; // 阻止默认 form 跳转
    });

    util.on('lay-on', {
        // 获取验证码
        'get-vercode': (e) => {
            if (e.hasClass('layui-disabled')) return;
            // 验证通过
            if(form.validate('#username')){
                let val = $('#username').val();
                if (!val) return message(`请正确填写${loginType ? '邮箱' : '用户名'}！`, 0);

                let countdown = 60, originalText = e.text();
                //更新按钮
                e.addClass(`layui-disabled`).prop('disabled', true).text(`重新发送(${countdown})`);
                // 定义倒计时函数
                const timer = setInterval(() => {
                    countdown--;
                    // 更新按钮文字显示倒计时
                    e.text(`重新发送(${countdown})`);
                    // 倒计时结束
                    if (countdown <= 0) {
                        clearInterval(timer);
                        // 恢复按钮状态和文字
                        e.text(originalText).removeClass('layui-disabled').prop('disabled', false);
                    }
                }, 1000);

                $.ajax({
                    url:`${layui.cache.BASE_API}code${loginType > 0 ? '/email':''}`,
                    data: (loginType > 0) ? {email : val} : {username : val},
                    type:'get', dataType:'json',
                    success:(data) => {
                        if (data.code === 0) {
                            message('验证码已发送，请查收！', 1);
                        } else {
                            clearInterval(timer);
                            e.text(originalText).removeClass('layui-disabled').prop('disabled', false);
                            message(data.msg)
                        }
                    },
                })
            }
        },
        'email-login': (e) => {
            if (/邮箱登陆/.test(e.text().trim())) {
                loginType = 1
                $('.lanj838-form-user-icon').removeClass('layui-icon-username').addClass('layui-icon-email')
                $('#username').attr('type', 'email').attr('lay-verify','required|email').attr('name', 'email').attr('placeholder', '电子邮箱').attr('lay-reqtext', '请填写电子邮箱')
                e.html('<i class="layui-icon layui-icon-username"></i> 账号登陆')
            }else{
                loginType = 0
                $('.lanj838-form-user-icon').removeClass('layui-icon-email').addClass('layui-icon-username')
                $('#username').attr('type', 'text').attr('lay-verify','required').attr('name', 'username').attr('placeholder', '用户名').attr('lay-reqtext', '请填写用户名')
                e.html('<i class="layui-icon layui-icon-email"></i> 邮箱登陆')
            }
            return false
        },
    });
    //layer.msg('请填写用户名和验证码后，点击登录按钮登录系统。', {icon:1})
});